import React from "react";

export const ArticleContext = React.createContext(false);
export const AutherContext = React.createContext(false);
export const CategoryContext = React.createContext(false);
export const SiteSettingContext = React.createContext(false);
export const ToastContext = React.createContext(false);
export const UserContext = React.createContext(false);
export const ImportContext = React.createContext(null);
